import BaseModule from '@/store/baseModule';
import BaseModulePlugins from '@/store/baseModule/plugins';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';
import registerPayloadTypesOrigins from '../origins';

const customGetters = {
  payloadTypesOrigin: (state, getters) => (originId) => {
    return getters.items.filter((item) => item.ori_id === originId);
  },
};

export default (store) => {
  store.registerModule(
    ['logbook', 'payloadTypes'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.MYPREDITY_BASE_URI}/logbooks/payloads`,
        }),
        retry: { nbLeft: 3, timeout: 2000 },
      }),
      customGetters,
    })
  );

  const basePlugin = new BaseModulePlugins({
    module: 'logbook/payloadTypes',
    store,
  });

  basePlugin.onInit(() => store.dispatch('logbook/payloadTypes/initItems'));

  registerPayloadTypesOrigins(store);
};
